const BLOCKED_OPACITY = 0.55;

export const getRowStyles = isBlocked => ({
  display: 'flex',
  gap: '12px',
  cursor: 'pointer',
  opacity: isBlocked ? BLOCKED_OPACITY : 1,
});

// paddingTop drops the node so its center lines up with the step title's first
// line (the card's own top padding pushes the title down ~14px); without it the
// node floats above the title.
export const nodeColumnStyles = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: '14px',
};

// A subtle expanding ring around the running step's status node. Position-absolute
// over a zero-size anchor so it never shifts the node's footprint, and gated by the
// caller to the running status only — completed/failed/pending nodes stay static.
export const nodeStyles = {
  position: 'relative',
  display: 'inline-flex',
};

export const runningPulseStyles = ({ palette }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  transform: 'translate(-50%, -50%)',
  border: `2px solid ${palette.primary.main}`,
  pointerEvents: 'none',
  animation: 'aiStepNodePulse 1.6s ease-out infinite',

  '@keyframes aiStepNodePulse': {
    '0%': { opacity: 0.5, transform: 'translate(-50%, -50%) scale(0.8)' },
    '100%': { opacity: 0, transform: 'translate(-50%, -50%) scale(1.6)' },
  },
});

// Absolute line centered under the node, running from just below it down past
// the card's bottom margin to meet the next step's node — so it bridges the gap
// regardless of card height instead of relying on flex fill.
export const getConnectorStyles = ({ backgroundColor }) => ({
  position: 'absolute',
  top: '32px',
  bottom: '-24px',
  left: '50%',
  width: '2px',
  marginLeft: '-1px',
  borderRadius: '1px',
  backgroundColor,
});

export const getRowCardStyles =
  isSelected =>
  ({ palette, transition }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    flex: 1,
    minWidth: 0,
    marginBottom: '10px',
    padding: '12px 16px',
    borderRadius: '10px',
    border: `1px solid ${isSelected ? palette.blue.light : palette.divider}`,
    backgroundColor: isSelected ? palette.blue.extraSoft : palette.background.paper,
    boxShadow: isSelected ? palette.shadow?.s : 'none',
    transition: transition?.default,

    '&:hover': {
      borderColor: isSelected ? palette.blue.light : palette.border.input,
    },
  });

export const stepNameStyles = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const metaRowStyles = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '8px',
  rowGap: '4px',
  color: ({ palette }) => palette.text.dark,
};

export const durationStyles = {
  marginLeft: 'auto',
  whiteSpace: 'nowrap',
  fontVariantNumeric: 'tabular-nums',
};
